import React, { Component } from 'react';

import config from '@config';
import ViewToggle from './viewtoggle';
import RegionSelector from './regionselector';
import PixelRatio from './pixelratio';
import AccessibilityToggle from './accessibilitytoggle';
import HighlightToggle from './highlighttoggle';

class Toolbar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      expended: false,
    };
  }

  handleExpendClick() {
    this.setState({
      expended: !this.state.expended,
    });
  }

  getHighlightToggle(view) {
    if (window.innerWidth > config.breakpoints.mobile) {
      if (view !== 'text') {
        return <HighlightToggle />;
      } else {
        return <div></div>;
      }
    }
  }

  render() {
    const { view } = this.props;

    return (
      <div className="tvg-toolbar">
        <ViewToggle />
        {view === 'text' && window.innerWidth < config.breakpoints.mobile && (
          <React.Fragment>
            <div
              className="fv-btn tvg-region-selector"
              onClick={this.handleExpendClick.bind(this)}
            >
              <div className="tvg-region-selector__inner">
                <div className="fv-btn tvg-region-selector__cta">
                  Filters
                  <i className="icon-filter" />
                </div>
              </div>
            </div>
            {this.state.expended && (
              <div className="tvg-toolbar__text">
                <React.Fragment>
                  <HighlightToggle />
                  <AccessibilityToggle />
                  <div className="tvg-toolbar__filters">
                    <RegionSelector />
                  </div>
                </React.Fragment>
              </div>
            )}
          </React.Fragment>
        )}
        {view === 'text' && window.innerWidth > config.breakpoints.mobile && (
          <AccessibilityToggle />
        )}
        {this.getHighlightToggle(view)}
        {view !== 'text' && (
          <div className="tvg-toolbar__filters">
            <PixelRatio />
            <RegionSelector />
          </div>
        )}
      </div>
    );
  }
}

export default Toolbar;
